import { render, staticRenderFns } from "./EstrelasAvaliacao.vue?vue&type=template&id=24dab506&scoped=true"
import script from "./EstrelasAvaliacao.vue?vue&type=script&lang=js"
export * from "./EstrelasAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dab506",
  null
  
)

export default component.exports